import React, { useState, useRef, useEffect, useId } from "react";
import "./verifyInsurance.css";
import Widgets from "../../widgets";
import { useTranslation } from "react-i18next";
import SelectCard from "../../widgets/selectCard/selectCard";
import ToastPopup from "../../widgets/Toast/toastPopup";
import { useDispatch, useSelector } from "react-redux";
import { editPatientProfile, uploadMedia, verifyRelativeProfileRequest } from "../../modules/patientProfile/patientProfileThunk";
import { resetUploadMedia, resetRejectEditReq, resetEditProfileRequest } from "../../modules/patientProfile/patientProfileSlice";
import SelectDropdown from "../../widgets/SelectDropdown/selectDropdown";
import { useNavigate } from "react-router-dom";
import { setStatus } from "../../modules/status/status";
import { setVerifyType } from "../../modules/status/verificationType";

const VerifyInsurance = ({ userId, setSelectedView, setPage }) => {
  const navigate = useNavigate();
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const { updateEditRequestData } = useSelector((state) => state.patientProfile);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [action, setAction] = useState("");
  const {status}=useSelector((state)=>state.status);
  const [insuranceimages, setInsuranceImages] = useState([
    {
      frontImage: "",
    },
    { frontImage: "" },
    { frontImage: "" },
  ]);

  useEffect(() => {
    if (updateEditRequestData?.status === "success" && status === "OPEN") {
      dispatch(setStatus("IN_REVIEW"));
      ToastPopup.success(t("assignedSuccess"));
    }
  }, [updateEditRequestData]);

  const [imageToPreview, setImageToPreview] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [showDel, setShowDel] = useState(false);
  const [isChecked, setIsChecked] = useState([]);
  const [insuranceIndicator, setInsuranceIndicator] = useState("");
  const [checkedInsurance, setCheckedInsurance]=useState([]);

  const modalRef = useRef(null);
  const { uploadMediaSuccess, uploadMediaErr, rejectHnReqErr, rejectHnReq, rejectEditReqSuccess, rejectEditReqErr, patientEditRequest, patientEditRequestError, verifyRelativeProfile } = useSelector(
    (state) => state.patientProfile,
  );
  const insuranceData = patientEditRequest?.data?.request?.insurance;
  const verifiedInsuranceData = patientEditRequest?.data?.verifiedInsurances;

    useEffect(()=>{
      if (patientEditRequest) {
        setInsuranceIndicator(patientEditRequest?.data?.request?.relative?.insuranceCategory ?? '')
      }
    },[patientEditRequest])
  useEffect(() => {
    if (rejectEditReqErr) {
      ToastPopup.error(rejectEditReqErr);
    }
    if (rejectEditReqSuccess && rejectEditReqSuccess.status === "success") {
      setSelectedView("patientProfileList");
    }
    dispatch(resetRejectEditReq());
  }, [rejectEditReqSuccess, rejectEditReqErr]);

  const [insuranceCompanies, setInsuranceCompanies] = useState([
    {
      name: "Default Insurance Company",
      verified: false,
      insuranceIndicator: "PVI",
    },
  ]);

  // useEffect(() => {
  //   const backendCheckboxes = insuranceData.map(() => false);
  //   const remainingCheckboxes = Array(3 - backendCheckboxes.length).fill(true);
  //   setIsChecked([...backendCheckboxes, ...remainingCheckboxes]);
  // }, [insuranceData]);

  const handleInsuranceIndicatorChange = (value) => {
    setInsuranceIndicator(value);
  };
  const insuranceOptions = [`${t("opdInternationalAssured")}`, `${t("opdLocalInsured")}`, `${t("opdSubsidized")}`];
  const handleToggleVerified = (index) => {
    setInsuranceCompanies((prevCompanies) => prevCompanies.map((company, i) => (i === index ? { ...company, verified: !company.verified } : company)));
  };

  const handleCheckboxChange = (index) => {
        const updatedChecked = [...isChecked];
        updatedChecked[index] = !updatedChecked[index];
        setIsChecked(updatedChecked);
  };

  const handleDeleteImage = (index, isFront) => {
    setInsuranceImages((prevImages) => {
      const newImages = [...prevImages];
      const updatedImage = { ...newImages[index] };
      if (isFront) {
        updatedImage.frontImage = "";
      }
      newImages[index] = updatedImage;
      ToastPopup.success(t("imageDeleted"));
      return newImages;
    });
    setInsuranceCompanies((prevCompanies) => {
      const newCompanies = [...prevCompanies];
      if (isFront && newCompanies[index]?.insurance) {
        newCompanies[index].insurance.image = ""; // Clear the image in the company object
      }
      return newCompanies;
    });
  };

  const handleFrontImageUpload =
    (index, idType) =>
    ({ files }) => {
      if (!insuranceCompanies[index].insurance.company.trim()) {
        ToastPopup.error(t("insuranceCompanyNameRequired"));
        return;
      }
      if (files && files.length > 0) {
        dispatch(uploadMedia({ files }));
        setAction({ index, idType });
        const imageUrl = URL.createObjectURL(files[0]);
        ToastPopup.success(t("frontImageUploaded"));
        setInsuranceImages((prevImages) => {
          const updatedImages = [...prevImages];
          if (!updatedImages[index]) {
            updatedImages[index] = { frontImage: imageUrl };
          } else {
            updatedImages[index].frontImage = imageUrl;
          }
          return updatedImages;
        });
      }
    };

  useEffect(() => {
    if (insuranceData && Array.isArray(insuranceData)) {
      const mappedCompanies = insuranceData.map((insurance) => ({
        name: insurance.name || "Default Insurance Company",
        image: insurance.image || "hh",
        // verified: company.verified || false,
        // insuranceIndicator: company.insuranceIndicator || "PVI",
        // insurance: {
        //   company: company.insurance?.company || "",
        //   image: company.insurance?.image || "",
        // },
      }));

      setInsuranceCompanies(mappedCompanies);
    }
  }, [insuranceData]);

  useEffect(() => {
    if (uploadMediaErr) {
      ToastPopup.error(uploadMediaErr);
    }
    if (uploadMediaSuccess && uploadMediaSuccess.status === "success") {
      const url = uploadMediaSuccess?.data?.urls?.[0];
      if (url) {
        const finalUrl = url.replace(/ /g, "%20");
        const { index, idType } = action; // Ensure action includes the index

        setInsuranceCompanies((prevCompanies) => {
          const updatedCompanies = [...prevCompanies];
          if (updatedCompanies[index]) {
            // i remove idType === "frontImg" &&  this from condition
            updatedCompanies[index].insurance.image = finalUrl; // Update the image field
          }

          return updatedCompanies;
        });

        setInsuranceImages((prevImages) => {
          const updatedImages = [...prevImages];
          if (idType === "frontImg" && updatedImages[index]) {
            updatedImages[index].frontImage = finalUrl;
          }
          return updatedImages;
        });
      }
    }
  }, [uploadMediaErr, uploadMediaSuccess, action]);

  const handleShowImg = (image) => {
    if (image) {
      setImageToPreview(image);
      setShowModal(true);
      setTimeout(() => {
        setVisible(true);
        setShowDel(true);
      }, 300);
    }
  };

  const handleCloseWithTransition = () => {
    setVisible(false);
    setTimeout(() => {
      setShowModal(false);
      setShowDel(false);
    }, 300);
  };

  const handleInsuranceNameChange = (index) => (event) => {
    const newCompanies = [...insuranceCompanies];
    newCompanies[index].insurance.company = event.target.value;
    setInsuranceCompanies(newCompanies);
  };

  const handleAddCompany = () => {
    if (insuranceCompanies.length === 3) { return; }

    const newCompany = {
      insurance: {
        company: "",
        image: "",
      }
    };
    const newImage = { frontImage: "" };

    setInsuranceCompanies((prevCompanies) => [...prevCompanies, newCompany]);
    setInsuranceImages((prevImages) => [...prevImages, newImage]);

    ToastPopup.success(t("insuranceCompanyAdded"));
  };

  const handleRemoveCompany = (index) => {
    const companyFromBackend = insuranceData && insuranceData[index];

    if (companyFromBackend) {
      ToastPopup.error(t("cannotDeleteBackendCompany"));
      return;
    }

    if (insuranceCompanies.length === 1) {
      ToastPopup.error(t("cannotDeleteLastCompany"));
      return;
    }

    const updatedCompanies = insuranceCompanies.filter((_, i) => i !== index);
    const updatedImages = insuranceimages.filter((_, i) => i !== index);
      const updatedIsChecked = isChecked.filter((_, i) => i !== index);

    setInsuranceCompanies(updatedCompanies);
    setInsuranceImages(updatedImages);
     setIsChecked(updatedIsChecked); 
    setInsuranceImages(updatedImages);

    ToastPopup.success(t("insuranceCompanyDeleted"));
  };

  const isAddButtonDisabled = () => {
    const lastCompanyIndex = insuranceCompanies.length - 1;

    if (lastCompanyIndex < 0) {
      return true;
    }

    const lastCompany = insuranceCompanies[lastCompanyIndex];
    const lastImage = insuranceimages[lastCompanyIndex]?.frontImage;

    const companyName = lastCompany.name || "";

    return !companyName.trim() || !lastImage;
  };
  const handleSubmit = () => {
    let isValid = true;
     const checkedUnverifiedData = mergedInsuranceList.filter(
    (insurance) => !insurance.verified && isChecked[insurance.index] // only take verified insurance
      );

    
    if (!insuranceIndicator) {
      ToastPopup.error(t("insuranceIndicatorRequired"));
      return isValid = false;
    }
    for (const item of insuranceCompanies) {
      const { insurance } = item;
       if (!insurance.company || !insurance.image) {
    ToastPopup.error("Please fill all insurance details");
    isValid = false;
    break;
  }
    }
    const allUnchecked = isChecked.every((val) => val === false);
    if (isChecked.length === 0 || allUnchecked) {
      ToastPopup.error(t("validateInsurance"));
      return isValid = false;
    }

    if (insuranceIndicator && isValid  ) {
      setCheckedInsurance(checkedUnverifiedData)
      openconfirmModal();
      const submittedData = {
        insuranceCompanies: insuranceCompanies.map((company) => company.name),
        insuranceImages: insuranceimages.map((img) => img.frontImage),
        insuranceIndicator: insuranceIndicator,
      };

    }
  };

  useEffect(() => {
    if (insuranceData && insuranceData.length) {
      setInsuranceCompanies(insuranceData);
    }
  }, [insuranceData]);

  const openRejectModal = () => {
    setShowRejectModal(true);
  };

  const openconfirmModal = () => {
    setShowConfirmModel(true);
  };

  const handleCancel = () => {
    setShowRejectModal(false);
    setShowConfirmModel(false);
  };

  const handleConfirm = () => {
    setShowRejectModal(false);
    setShowConfirmModel(false);

    const data = {
      insuranceCategory: insuranceIndicator,
      insurances:checkedInsurance,
    };
    if (showConfirmModel && insuranceIndicator) {
      dispatch(verifyRelativeProfileRequest({ userId, data }));
      setSelectedView("patientProfileList");
    }
  };

const mergedInsuranceList = [
  ...(Array.isArray(insuranceCompanies) ? insuranceCompanies : []).map((item, index) => ({
    ...item,
    index,
    verified: false
  })),
  ...(Array.isArray(verifiedInsuranceData) ? verifiedInsuranceData : []).map((item, index) => ({
    ...item,
    index: (insuranceCompanies?.length || 0) + index,
    verified: true
  })),
];

  return (
    <div className="verification-class">
      <div className="verification-box">
     {mergedInsuranceList.map((insurance, i) => (
  <div className="secondary-div" key={i}>
    <div className="ambulance-heading-flex">
      <div className="ambulance-heading margin">
        <input
          type="checkbox"
          checked={insurance.verified ? true : isChecked[insurance.index] || false}
          disabled={insurance.verified}
          onChange={() =>
            !insurance.verified && handleCheckboxChange(insurance.index)
          }
          style={{ marginRight: "0.8rem", marginTop: "1.5rem" }}
        />
        {t("insurancecompany")} {i + 1}
        <div className="outer-div-unverified">
          <button
            className={`styled-button-${
              insurance.verified || isChecked[insurance.index]
                ? "verified"
                : "unverified"
            }`}
            onClick={() =>
              !insurance.verified && handleToggleVerified(insurance.index)
            }
            disabled={insurance.verified}
          >
            {insurance.verified || isChecked[insurance.index]
              ? t("verified")
              : t("unverified")}
          </button>
        </div>
      </div>
    </div>

    <div className="form-group">
      <label>
        {t("insurancecompanyname")}
        <span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="text"
        id={`brand-name-${i}`}
        name={`brand-name-${i}`}
        placeholder={t("enterName")}
        value={
          insurance.verified
            ? insurance.company || ""
            : insurance?.insurance?.company
        }
        onChange={
          insurance.verified ? undefined : handleInsuranceNameChange(insurance.index)
        }
        disabled={insurance.verified || insuranceData[insurance.index]}
        readOnly={insurance.verified}
      />
    </div>

    <div className="upload-info-ambulance gapbtw">
      <SelectCard
        image={
          insurance.verified
            ? insurance?.image
            : insurance?.insurance?.image || insuranceimages[insurance.index]?.frontImage
        }
        setImage={() =>
          !insurance.verified && handleDeleteImage(insurance.index, true)
        }
        title={t("frontpage")}
        onImageUpload={
          insurance.verified ? () => {} : handleFrontImageUpload(insurance.index)
        }
        handleShowImg={() =>
          handleShowImg(
            insurance.verified
              ? insurance?.image
              : insuranceimages[insurance.index]?.frontImage
          )
        }
        onDelete={() =>
          !insurance.verified && handleDeleteImage(insurance.index, true)
        }
        disabled={insurance.verified || insuranceData[insurance.index]}
      />
    </div>

    {!insurance.verified && (
      <div className="button-container-right">
        {!insurance._id && insurance.index >= insuranceCompanies.length - 1 && (
          <button
            className="cancel-button marginright"
            onClick={() => handleRemoveCompany(insurance.index)}
            style={{ marginRight: "2rem" }}
            disabled={insuranceCompanies.length === 1}
          >
            {t("deletee")}
          </button>
        )}
        {insurance.index === insuranceCompanies.length - 1 && (
          <button
            className="submit-button"
            onClick={handleAddCompany}
            disabled={insuranceCompanies.length === 3}
            style={{
              cursor: isAddButtonDisabled() ? "not-allowed" : "pointer",
              alignItem: insuranceCompanies.length === 3 ? "auto" : "1rem",
              cursor: insuranceCompanies.length === 3 ? "auto" : "",
            }}
          >
            {t("add")}
          </button>
        )}
      </div>
    )}

    {showModal && (
      <div className="show-id-preview">
        <div className="id-pos-rel">
          <button
            className={`card-delete-btn close ${
              visible ? "fade-out" : ""
            }`}
            onClick={handleCloseWithTransition}
          />
          <img
            className={`preview-id-image ${visible ? "visible fade-in" : ""}`}
            src={imageToPreview}
            alt="insurance-img"
            ref={modalRef}
          />
          {showDel && (
            <button
              className={`card-delete-btn ${visible ? "fade-out" : ""}`}
              onClick={handleCloseWithTransition}
            />
          )}
        </div>
      </div>
    )}
  </div>
      ))}



        <div className="Insurance-Indicator">
          <div className="ambulance-heading-flex">
            <div className="form-group third" style={{ marginLeft: "6rem" }}>
              <label className="insuranceindi">
                {t("insuranceindicator")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <div
                className="form-group insurance-select"
                style={{
                  marginLeft: "0rem",
                  paddingLeft: "0rem",
                  marginTop: "0rem",
                }}
              >
                <Widgets.SelectDropdown options={insuranceOptions} selectedValue={insuranceIndicator} onChange={handleInsuranceIndicatorChange} placeholder={t("selCategory")} big />
              </div>
            </div>
          </div>
        </div>
        <div className="button-container">
          <button className="cancel-button" onClick={openRejectModal}>
            {t("reject")}
          </button>
          {showRejectModal && <Widgets.RejectEdit showModal={showRejectModal} handleCancel={handleCancel} handleConfirm={handleConfirm} reason="rejectReason" userId={userId} />}
          <button
            className="submit-button"
            onClick={() => {
              handleSubmit();
            }}
          >
            {t("submit")}
          </button>
          {showConfirmModel && (
            <Widgets.ConfirmModal
              showModal={showConfirmModel}
              handleCancel={handleCancel}
              handleConfirm={handleConfirm}
              heading="Confirm Your Action"
              description="Are you sure you want to proceed with this action?"
              postive={true}
              reject={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyInsurance;
